import { FALSE, TRUE, UNDEFINED } from "constants/primitives";
import { useEffect, useState } from "preact/hooks";

import useAppState from "./useAppState";
import { ITCFGatpVendorList as IGoogleVendorListResponse } from "types/tcf";
import fetchGoogleVendorList from "helpers/tcf/fetchGoogleVendorList";

let cachedGV: IGoogleVendorListResponse;

const useLoadGoogleVendorList = (): [
  IGoogleVendorListResponse | undefined,
  boolean
] => {
  const { widgetConfig } = useAppState();
  // show loading state only when not using cached data
  const [isLoading, setIsLoading] = useState<boolean>(!cachedGV);
  const [data, setData] = useState<IGoogleVendorListResponse | undefined>(
    undefined
  );

  useEffect(() => {
    // Check if it should even be loaded
    if (widgetConfig.acEnabled) {
      loadGV();
    }
  }, []);

  const loadGV = () => {
    return new Promise((resolve, reject) => {
      if (!widgetConfig.acEnabled) {
        setData([]);
        setIsLoading(FALSE);
        return;
      }
      try {
        // use cached data if available
        if (cachedGV) {
          setData(cachedGV);
          setIsLoading(FALSE);
          return;
        }

        setData(UNDEFINED);
        setIsLoading(TRUE);

        fetchGoogleVendorList(widgetConfig.version)
          .then((res) => {
            cachedGV = res;
            setData(cachedGV);
          })
          .catch((err) => {
            console.error("Error fetching purposes:", err);
          })
          .finally(() => {
            setIsLoading(FALSE);
          });

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  };

  return [data, isLoading];
};

export default useLoadGoogleVendorList;
